/**
 * Wire messages between browser ↔ hub ↔ hermes-client (JSON over WebSocket text frames).
 * Binary terminal payloads are base64-encoded in `data` fields.
 */
const PROTOCOL_VERSION = 1;
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
export function parseRmtMessage(raw) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        return null;
    }
    if (!isRecord(parsed))
        return null;
    if (parsed.v !== PROTOCOL_VERSION)
        return null;
    const type = parsed.type;
    if (typeof type !== "string")
        return null;
    switch (type) {
        case "agent_hello":
            if (typeof parsed.agentId !== "string")
                return null;
            return { v: PROTOCOL_VERSION, type, agentId: parsed.agentId };
        case "browser_hello":
            return { v: PROTOCOL_VERSION, type };
        case "session_request": {
            if (typeof parsed.requestId !== "string")
                return null;
            const cols = Number(parsed.cols);
            const rows = Number(parsed.rows);
            if (!Number.isFinite(cols) || !Number.isFinite(rows))
                return null;
            return {
                v: PROTOCOL_VERSION,
                type,
                requestId: parsed.requestId,
                cols,
                rows,
            };
        }
        case "session_opened": {
            if (typeof parsed.requestId !== "string")
                return null;
            if (typeof parsed.sessionId !== "string")
                return null;
            const cols = Number(parsed.cols);
            const rows = Number(parsed.rows);
            if (!Number.isFinite(cols) || !Number.isFinite(rows))
                return null;
            return {
                v: PROTOCOL_VERSION,
                type,
                requestId: parsed.requestId,
                sessionId: parsed.sessionId,
                cols,
                rows,
            };
        }
        case "session_open": {
            if (typeof parsed.requestId !== "string")
                return null;
            if (typeof parsed.sessionId !== "string")
                return null;
            const cols = Number(parsed.cols);
            const rows = Number(parsed.rows);
            if (!Number.isFinite(cols) || !Number.isFinite(rows))
                return null;
            return {
                v: PROTOCOL_VERSION,
                type,
                requestId: parsed.requestId,
                sessionId: parsed.sessionId,
                cols,
                rows,
            };
        }
        case "session_ready": {
            if (typeof parsed.sessionId !== "string")
                return null;
            return { v: PROTOCOL_VERSION, type, sessionId: parsed.sessionId };
        }
        case "stdin":
        case "stdout": {
            if (typeof parsed.sessionId !== "string")
                return null;
            if (typeof parsed.data !== "string")
                return null;
            return { v: PROTOCOL_VERSION, type, sessionId: parsed.sessionId, data: parsed.data };
        }
        case "resize": {
            if (typeof parsed.sessionId !== "string")
                return null;
            const cols = Number(parsed.cols);
            const rows = Number(parsed.rows);
            if (!Number.isFinite(cols) || !Number.isFinite(rows))
                return null;
            return { v: PROTOCOL_VERSION, type, sessionId: parsed.sessionId, cols, rows };
        }
        case "session_close": {
            if (typeof parsed.sessionId !== "string")
                return null;
            const reason = typeof parsed.reason === "string" ? parsed.reason : undefined;
            return { v: PROTOCOL_VERSION, type, sessionId: parsed.sessionId, reason };
        }
        case "error": {
            if (typeof parsed.message !== "string")
                return null;
            const sessionId = typeof parsed.sessionId === "string" ? parsed.sessionId : undefined;
            return { v: PROTOCOL_VERSION, type, message: parsed.message, sessionId };
        }
        default:
            return null;
    }
}
export function stringifyRmtMessage(msg) {
    return JSON.stringify(msg);
}
//# sourceMappingURL=index.js.map